import {
    BanknotesIcon,
    Bars3CenterLeftIcon,
} from "@heroicons/react/24/outline";

const Payment = [
    {
        path: "payments",
        fullPath: "call-center/payments",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Payments",
        displayPath: "Call Center > Payments",
        icon: BanknotesIcon,
        children: [
            // {
            //     path: "bkash-refunds",
            //     fullPath: "call-center/payments/bkash-refunds",
            //     exact: true,
            //     showChildren: false,
            //     sidebarMenu: true,
            //     displayName: "bKash Refunds",
            //     displayPath: "Call Center > Payments > bKash Refunds",
            //     icon: Bars3CenterLeftIcon,
            //     children: [
            //         {
            //             index: true,
            //             async lazy() {
            //                 const component = await import(
            //                     "../../pages/CallCenter/Complain/List"
            //                 );
            //                 return {
            //                     Component: component.default,
            //                 };
            //             },
            //             // permissions: ["callcenter-payment-bkash-refunds"],
            //         },
            //     ],
            // },
            {
                path: "refunds",
                fullPath: "call-center/payments/refunds",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Refunds",
                displayPath: "Call Center > Payments > Refunds",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Payment/Refunds/List"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-payment-refunds-list"],
                    },
                ],
            },
            {
                path: "payments-history",
                fullPath: "call-center/payments/payments-history",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Payments History",
                displayPath: "Call Center > Payments > Payments History",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Payment/PaymentsHistory/List"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-payment-history-list"],
                    },
                ],
            },
        ],
    },
];

export default Payment;
